"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groups = void 0;
var qs = require('qs');
exports.groups = function (axios) {
    return {
        getAuthorityGroups: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/authority/groups?" + query);
        },
        postAuthorityGroups: function (request) {
            return axios.post('/authority/groups', request.data);
        },
        getAuthorityGroupsExists: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/authority/groups/exists?" + query);
        },
        getAuthorityGroupsByGroupNo: function (request) {
            return axios.get("/authority/groups/" + request.pathParams.authorityGroupNo);
        },
        putAuthorityGroupsByGroupNo: function (request) {
            return axios.put("/authority/groups/" + request.pathParams.authorityGroupNo, request.data);
        },
        deleteAuthorityGroupsByGroupNo: function (request) {
            var query = qs.stringify(request.params);
            return axios.delete("/authority/groups/" + request.pathParams.authorityGroupNo + "?" + query);
        },
        getAuthorityGroupsAdminsByGroupNo: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/authority/groups/" + request.pathParams.authorityGroupNo + "/admins?" + query);
        }
    };
};
